(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_spx-header-search"] && !Shopify.designMode) return;
  try {
    // Scroll lock 逻辑已移至 spx-header-search-external-mega.js 统一管理
  // 此处仅保留 dev mode 相关的状态同步
  (() => {
    const SEARCH_SELECTOR = '.spx-header-search-shell';
    const INPUT_SELECTOR = '.spx-header-search__input';
    const DEV_HASH = '#dev';
    const DEV_QUERY_KEYS = ['spx_search_dev', 'spxsearchdev'];

    const isDevSearchMode = () => {
      const searchParams = new URLSearchParams(window.location.search);
      return DEV_QUERY_KEYS.some((key) => searchParams.get(key) === '1') || window.location.hash === DEV_HASH;
    };

    const findShellByTarget = (target) => {
      if (!(target instanceof Element)) return null;
      return target.closest(SEARCH_SELECTOR);
    };

    const findInputByTarget = (target) => {
      if (!(target instanceof Element)) return null;
      const input = target.closest(INPUT_SELECTOR);
      return input instanceof HTMLInputElement ? input : null;
    };

    const syncEmptyState = (searchRoot, input) => {
      if (!input.value.trim()) {
        searchRoot.dataset.empty = 'true';
      } else {
        searchRoot.dataset.empty = 'false';
      }
    };

    const onDocumentInput = (event) => {
      const input = findInputByTarget(event.target);
      if (!input) return;

      const searchRoot = findShellByTarget(input);
      if (!(searchRoot instanceof HTMLElement)) return;

      syncEmptyState(searchRoot, input);
    };

    const openSearchInDevMode = () => {
      const enabled = isDevSearchMode();
      const searchRoots = Array.from(document.querySelectorAll(SEARCH_SELECTOR)).filter(
        (el) => el instanceof HTMLElement
      );

      if (!searchRoots.length) return;

      if (!enabled) {
        searchRoots.forEach((searchRoot) => {
          if (!(searchRoot instanceof HTMLElement)) return;
          if (searchRoot.dataset.devOpen === 'true') {
            searchRoot.dataset.devOpen = 'false';
          }
          if (searchRoot.dataset.empty) {
            searchRoot.dataset.empty = 'false';
          }
        });
        return;
      }

      searchRoots.forEach((searchRoot) => {
        if (!(searchRoot instanceof HTMLElement)) return;
        searchRoot.dataset.devOpen = 'true';
        searchRoot.dataset.empty = 'true';
      });

      const firstSearch = searchRoots[0];
      const input = firstSearch.querySelector(INPUT_SELECTOR);
      if (input instanceof HTMLInputElement) {
        requestAnimationFrame(() => {
          input.focus();
        });
      }
    };

    document.addEventListener('input', onDocumentInput);
    window.addEventListener('hashchange', openSearchInDevMode);
    requestAnimationFrame(openSearchInDevMode);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_spx-home-banner-card-group"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.spx-home-banner-card-group   .swiper', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      loop: false,
      navigation: false,
      pagination: false,
      scrollbar: false,
      breakpoints: {
        0: {
          centeredSlides: true,
          centeredSlidesBounds: true,
        },
        768: {
          centeredSlides: true,
          centeredSlidesBounds: true,
        },
      },
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["spx-variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__spxBundleListInit) return;
    window.__spxBundleListInit = true;

    const LIST_SELECTOR = '.spx-related-product-card-bundle-list';
    const ITEM_SELECTOR = ':scope > .spx-related-product-card-bundle-item';
    const VISIBLE_COUNT = 4;
    const bound = new WeakSet();

    // 按第 4 项底部到列表顶部的实际距离设置最大高度，兼容不同断点和内容高度
    const update = (list) => {
      const items = list.querySelectorAll(ITEM_SELECTOR);

      if (items.length <= VISIBLE_COUNT) {
        list.classList.remove('is-scrollable');
        list.style.removeProperty('--spx-bundle-list-max-height');
        list.removeAttribute('tabindex');
        return;
      }

      // 隐藏状态（非当前变体）无法测量，等显示后由 ResizeObserver 再次触发
      if (!list.offsetParent) return;

      const lastVisible = items[VISIBLE_COUNT - 1];
      const height = Math.ceil(
        lastVisible.getBoundingClientRect().bottom - list.getBoundingClientRect().top + list.scrollTop
      );
      const value = `${height}px`;

      if (list.style.getPropertyValue('--spx-bundle-list-max-height') !== value) {
        list.style.setProperty('--spx-bundle-list-max-height', value);
      }
      list.classList.add('is-scrollable');
      // 可滚动区域需要支持键盘聚焦后滚动
      list.setAttribute('tabindex', '0');
    };

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const list = entry.target.closest(LIST_SELECTOR);
        if (list) update(list);
      });
    });

    const bind = (root = document) => {
      root.querySelectorAll(LIST_SELECTOR).forEach((list) => {
        if (bound.has(list)) return;
        bound.add(list);

        resizeObserver.observe(list);
        list.querySelectorAll(ITEM_SELECTOR).forEach((item, index) => {
          if (index < VISIBLE_COUNT) resizeObserver.observe(item);
        });
        update(list);
      });
    };

    const init = () => {
      bind();

      // 变体切换或编辑器重渲染会插入新的列表，增量绑定
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (!(node instanceof Element)) continue;
            if (node.matches(LIST_SELECTOR) || node.querySelector(LIST_SELECTOR)) {
              bind(node.matches(LIST_SELECTOR) ? node.parentElement || document : node);
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
